import clsx from "clsx";

export const VerticalDivider = ({ className }: { className?: string }) => (
    <div className={clsx("h-full w-[1px] bg-[#CCCCCC]", className)} />
);
